module.exports = __webpack_public_path__ + "img/Batteryplantlogo.e9e50636.png";